import React from 'react';
import LegalDocument from '../../Components/LegalDocument';
import "./style.css";

const CookiePolicy = () => {
  return (
    <LegalDocument 
      documentType="cookie_policy"
      cssPrefix="cookiepolicy"
    />
  );
};

export default CookiePolicy;
